import { render, staticRenderFns } from "./layout-base.vue?vue&type=template&id=72f4328d"
import script from "./layout-base.vue?vue&type=script&lang=ts"
export * from "./layout-base.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports